import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShieldAlert, KeyRound } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API_URL = `${BACKEND_URL}/api`;

const ChangePasswordPage = () => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!oldPassword || !newPassword || !confirmPassword) return toast.error("Semua kolom wajib diisi!");
        if (newPassword !== confirmPassword) return toast.error("Password Baru dan Konfirmasi tidak sama!");
        if (newPassword.length < 6) return toast.error("Password Baru minimal 6 karakter!");

        setIsLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${API_URL}/auth/change-password`, {
                old_password: oldPassword,
                new_password: newPassword
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            toast.success("Password sukses diganti! Silakan ingat baik-baik.");
            
            // BERSAHABAT DENGAN PORTAL: Arahkan ke /portal setelah 1.5 detik
            setOldPassword(""); setNewPassword(""); setConfirmPassword("");
            setTimeout(() => navigate('/portal'), 1500);
            
        } catch (error) {
            toast.error(error.response?.data?.detail || "Gagal mengganti password.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto mt-10 p-6">
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
                <div className="bg-slate-900 p-8 text-center relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-900/40 via-slate-900 to-slate-900"></div>
                    <ShieldAlert size={48} className="text-blue-400 mx-auto relative z-10 mb-3" />
                    <h1 className="text-3xl font-black text-white relative z-10">Keamanan Akun</h1>
                    <p className="text-slate-400 mt-2 font-medium relative z-10">Pastikan Anda rutin mengganti kata sandi Anda demi keamanan.</p>
                </div>
                
                <form onSubmit={handleSubmit} className="p-8 space-y-6">
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Kata Sandi LAMA</label>
                        <input 
                            type="password" 
                            value={oldPassword} onChange={e=>setOldPassword(e.target.value)}
                            className="w-full p-3 border-2 rounded-xl focus:border-slate-800 focus:ring-4 focus:ring-slate-100 outline-none font-mono" 
                            placeholder="Masukkan password lama Anda..."
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 border-t pt-6">
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2 text-blue-600">Kata Sandi BARU</label>
                            <input 
                                type="password" 
                                value={newPassword} onChange={e=>setNewPassword(e.target.value)}
                                className="w-full p-3 border-2 border-blue-100 rounded-xl focus:border-blue-600 focus:ring-4 focus:ring-blue-50 outline-none font-mono" 
                                placeholder="Minimal 6 karakter"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2 text-blue-600">Ulangi Kata Sandi BARU</label>
                            <input 
                                type="password" 
                                value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)}
                                className="w-full p-3 border-2 border-blue-100 rounded-xl focus:border-blue-600 focus:ring-4 focus:ring-blue-50 outline-none font-mono" 
                                placeholder="Ketik ulang password baru..."
                            />
                        </div>
                    </div>

                    <div className="pt-4 flex gap-3">
                        {/* TOMBOL BATAL JUGA DIARAHKAN KE PORTAL */}
                        <button type="button" onClick={() => navigate('/portal')} className="w-full py-3.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold rounded-xl transition">Batal</button>
                        <button type="submit" disabled={isLoading} className="w-full py-3.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl shadow-lg transition flex items-center justify-center gap-2 disabled:opacity-50">
                            {isLoading ? "Menyimpan..." : <><KeyRound size={18}/> Update Password</>}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordPage;